// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"60309d6d4f2bd1b8","3468":"414c7efc01838865"}[chunkId] + ".css";
};